import * as React from 'react';
import classnames from 'classnames';

import {getLocalizedPrice} from "features/services/utils/env-helper";
import {getFormattedMessage} from "features/services/utils/language-helper";

import './_cards.scss';
import {ResidenceTags} from '@atoms/Tags/ResidenceTags';
import { getParkingStockType } from 'features/services/utils/name-helpers';
import {Headline} from '@atoms/Text/Headline';
import { HeadlineLevel, HeadlineFont } from 'features/ui/enums';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic table row data
    object: any;
    onParkingProject: boolean
}

export const ParkingCard: React.FunctionComponent<Props> = ({object, onParkingProject}) => {
    const classes = classnames('grid-table__card grid-table__card--no-hover', {
        'grid-table__card--with-tag': object.objectStatus,
    });

    return(
        <div className={classes}>
            {object.objectStatus && <ResidenceTags objectStatus={object.objectStatus} />}
            <Headline level={HeadlineLevel.H4} font={HeadlineFont.SERIF}>
                {onParkingProject 
                    ? getParkingStockType(object.carParkingStock)
                    : object.apartmentNumber
                }
            </Headline>
            <dl>
                {object.price && 
                    <>
                        <dt>{getFormattedMessage('jm.components.QuickFacts.price')}</dt>
                        <dd>{getLocalizedPrice(object.price)}</dd>
                    </>
                }
                {object.jmoyTotalPrice &&
                    <>
                        <dt>Velaton hinta</dt>
                        <dd>{getLocalizedPrice(object.jmoyTotalPrice)}</dd>
                    </>
                }
                {object.fee && 
                    <>
                        <dt>{getFormattedMessage('jm.components.QuickFacts.fee')}</dt>
                        <dd>{getLocalizedPrice(object.fee)}</dd>
                    </>
                }
            </dl>
        </div>
    )
};
